import React from 'react';
import styled from 'styled-components';
import axios from "axios";

const TestPage = () => {

  const test2 = async () => {
    await axios.get("http://localhost:3000/teachers")
        .then(res => {
          console.log("@res",res);
        })
  }
  const test = async () => {
    await axios.post("http://localhost:3000/users/",{
      name:"Ba",
      age:25
    })
        .then(res => {
          test2()
        })
  }
return(
  <Container>
  <h1
  onClick={test2}
  >Test</h1>
  </Container>
)

}
export default TestPage;

const Container = styled.div`

`;